document.addEventListener("DOMContentLoaded", () => {
    const overlayLogin = document.getElementById('overlay-login-logo');

    if (overlayLogin) {
        overlayLogin.addEventListener('click', () => {
            overlayLogin.classList.add('is-shown');
        });
    }
});